<template>
  <div class="config-table mt10">
    <div class="config-table-tip">
      <el-button v-if="hasAdd" type="primary" icon="el-icon-plus" class="mr10" @click="()=>$emit('add-click')">添加配置数据</el-button>
      使用模块: {{tip}}
    </div>
    <JtTable 
      :data="list"
      row-key="id"
      :header-cell-style="{background:'#e8eaec',color:'#333'}"
      stripe
    >
      <slot/>
    </JtTable>
  </div>
</template>

<script>
import { JtTable } from '@/components/Ele'
export default {
  name: 'ConfigTable',
  components: {
    JtTable
  },
  props: {
    list: {
      type: Array,
      default: ()=>[]
    },
    tip: String,
    hasAdd: Boolean
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.config-table {
  background: #fff;
  border-radius: 4px;
  &-tip {
    padding-top: 10px;
    margin: 0 0 12px 10px;
    color: #a7a7a7;
  }
}

</style>